const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const { logError } = require('../../logger');

const MolotovCocktail = function(battleState) {
  this.handle = 'molotov_cocktail';
  this.physical = true;
  this.ranged = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    var strikes = [];
    var dist;
    const dmg = BattleCalc.getEquippedAbility(actor,'molotov_cocktail').damage;
    var adjustedDamage;

    setTimeout(() => {
      try {
        if (
          !battleState ||
          !battleState.allUnits ||
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        for (var prop in battleState.allUnits) {
          var unit = battleState.allUnits[prop];
          dist = BattleCalc.boardDistance(victim, unit);
          adjustedDamage = dmg - dmg*dist/4;

          if (adjustedDamage > 5) {
            var strike = new StandardStrike(this, battleState);
            strikes.push(strike.execute(
              actor,
              unit,
              adjustedDamage,
              false,
            ));
            strike.actorId = actor.uid;
            strike.victimId = unit.uid;
          }
        }

        var result = {};
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.strikes = strikes;
        result.allPieces = battleState.allPieces;

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'MolotovCocktail',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.THROWN_SPEED, actor, victim));
  };
};
module.exports = MolotovCocktail;
